import { t } from 'i18next';
import * as yup from 'yup';

export const contactGroupSchema = () =>
  yup.object().shape({
    accountsReceivableId: yup.string().label(t('labelAcctsReceivableId')).nullable(),
    contactGrouping: yup.object().label(t('labelContactGrouping')).nullable(),
    domains: yup
      .array()
      .label(t('labelDomains'))
      .of(yup.object({ id: yup.string(), title: yup.string() })),
    externalCustomerNumber: yup
      .string()
      .label(t('labelExternalCustomerNumber'))
      .nullable()
      .matches(/^[0-9]{6}$/, {
        message: t('errorMustBeExactlyDigitsOrEmpty', { count: 6 }),
        excludeEmptyString: true,
      }),
    isCustomer: yup.boolean().label(t('labelIsCustomer')).nullable(),
    isVendor: yup.boolean().label(t('labelIsVendor')).nullable(),
    automatedPricing: yup.boolean().label(t('labelAutomatedPricing')).nullable(),
    autoLeadTimeEnabled: yup.boolean().label(t('labelContactGroupAutoLeadTimeEnabled')).nullable(),
    freightEnabled: yup.boolean().label(t('labelFreightEnabled')).nullable(),
    showInventory: yup.boolean().label(t('labelShowInventory')).nullable(),
    vendorId: yup.string().label(t('labelVendorId')).nullable(),
    vendorName: yup.string().label(t('labelVendorName')).nullable(),
    alternateVendorId: yup.string().label(t('labelAlternateVendorId')).nullable(),
    alternateVendorName: yup.string().label(t('labelAlternateVendorName')).nullable(),
  });
